import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from './styles';

type IProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
	styleDeclaration?: StyleDeclarationValue[] | StyleDeclarationValue;
};

export function ActionButton({ styleDeclaration, ...props }: IProps) {
	const styleDeclarations = Array.isArray(styleDeclaration) ? styleDeclaration : [styleDeclaration];
	return <button className={css(styleSheet.root, ...styleDeclarations)} {...props} />;
}
